(ns common.webstorage
  (:refer-clojure :exclude [get]))

(defn get
  "Get a value from a web storage by key"
  ([storage k] (get storage k nil))
  ([storage k not-found]
   (let [value (.get storage (name k))]
     (if (undefined? value)
       not-found
       (js->clj value :keywordize-keys true)))))

(defn save!
  "Saves a value into a web storage"
  [storage k v]
  (.set storage (name k) (clj->js v)))

(defn remove!
  "Remove a value from a web storage by key"
  [storage k]
  (.remove storage (name k)))
